export function isValidJSONString(string: string): boolean {
  try {
    JSON.parse(string);
  } catch (e) {
    console.error(e);
    return false;
  }
  return true;
}
